export const exportToCsv = (filename, data) => {
  if (!data || !data.length) {
    console.error("No data available to export");
    return;
  }
  const headers = Object.keys(data[0]).join(",") + "\n";

  const rows = data
    .map((row) =>
      Object.values(row)
        .map((value) => `"${value}"`)
        .join(",")
    )
    .join("\n");

  const csvContent = headers + rows;

  const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
  const link = document.createElement("a");
  const url = URL.createObjectURL(blob);
  link.href = url;
  link.setAttribute("download", filename);
  link.click();
  URL.revokeObjectURL(url);
};
